/**
 * Correlate API issues with backend `ux_http_request` logs via `X-Request-Id` (#26).
 * Does not log bodies or credentials, only status and header.
 */
export function logUxApiRequestId(
  label: string,
  res: Response,
  kind: "http_error" | "business_error" = "http_error"
): void {
  if (kind === "http_error" && res.ok) return;
  const requestId = res.headers.get("x-request-id");
  console.warn(
    `[ux-api:${label}] ${kind} status=${res.status} requestId=${requestId ?? "missing"}`
  );
}
